import React, { useEffect, useState, useCallback, useRef } from "react";
import styled from "styled-components/macro";
import { CreateUnitPage } from "../components/CreateUnit/CreateUnitPage";
import styles from "../components/Nav/nav.module.css";
import logo1 from "../images/logo1.png";
import { WizardUnitPage } from "../components/CreateUnit/Wizard/WizardUnitPage";
import axios from "axios";
import { FinishModal } from "../components/CreateUnit/FinishModal/FinishModal";
import { getPrismicItems } from "../actions/prismicAction";
import { useDispatch } from "react-redux";
import { CreateUnitPageYishai } from "../components/CreateUnitYishai/CreateUnitPage";

const CreateUnit = () => {
  const [columns, setColumns] = useState();
  const [rideItems, setRideItems] = useState();

  const [step, setStep] = useState(0);
  const [innerStep, setInnerStep] = useState(0);
  const [property, setProperty] = useState();
  const [name, setName] = useState("");
  const [roll, setRoll] = useState("null");
  const [email, setEmail] = useState("");
  const [propertySize, setPropertySize] = useState();
  const [people, setPeople] = useState();
  const [productsType, setProductsType] = useState();
  const [ipDetails, setIpDetails] = useState();
  const [orderNumber, setOrderNumber] = useState();
  const [city, setCity] = useState();
  const [open, setOpen] = useState(false);
  const wixDataId = useRef();
  const collectDate = useRef({});
  const isDemo = useRef(false);
  const dispatch = useDispatch();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getPrismicItems());
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        let data = response.data;
        setIpDetails(data);

        // setTimeout(() => {
        //   getOrderRes({ num: 36, mail: "tamir.rabia@gmail.com" });
        // }, 1000)
      })
      .catch((error) => {
        console.log(error);
      });
  }, [dispatch]);

  const saveData = () => {
    const address_components = city?.address_components;
    const newCity =
      address_components?.find((e) => e?.types?.includes("locality"))
        ?.long_name || ipDetails?.city;
    const newCountry =
      address_components?.find((e) => e?.types?.includes("country"))
        ?.long_name || ipDetails?.country_name;
    const address = city?.formatted_address;

    if (email.toLowerCase() === "yishai@tulu.io") {
      isDemo.current = true;
    }

    collectDate.current = {
      orderNumber,
      name: name.trim(),
      email: email.trim(),
      roll,
      city: newCity,
      country: newCountry,
      lat: city?.geometry?.location?.lat(),
      lng: city?.geometry?.location?.lng(),
      address,
      property: property?.key,
      propertySize: propertySize?.key,
      people: people?.map((item) => item.key),
      productsType: productsType?.map((item) => item.key),
      unitResults: columns && JSON.stringify(columns),
      rideResults: rideItems && JSON.stringify(rideItems),
    };

    if (!email.trim()) return;
    console.log(collectDate.current);

    const requestOptions = {
      method: "POST",
      headers: {},
      // mode: "no-cors",
      mode: "cors",
      cache: "no-cache",
      // credentials: 'same-origin',
      // redirect: 'follow',
      // referrerPolicy: 'no-referrer',
      body: JSON.stringify({ ...collectDate.current, _id: wixDataId.current }),
    };

    fetch("https://www.tulouapp.com/_functions/setuserDetails", requestOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.statusText === "Not Found") {
            console.error(
              "Error in component MyTable, error msg : file: './assets/data/test-table.json' ",
              response.statusText
            );
          }
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .catch((error) => console.error({ error: error }))
      .then((resData) => {
        if (!wixDataId.current) {
          wixDataId.current = resData._id;
          setOrderNumber(resData.orderNumber);
        }
        // console.log(resData)
      })
      .catch((error) =>
        console.error("Error in MyTable in parsing json data: ", error)
      );
  };

  useEffect(() => {
    saveData();
    // saveData reads the latest form state via closure but the save is meant to
    // fire only on these step/results transitions. Adding saveData (or its many
    // closed-over deps) would re-run the save on every field change, altering behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innerStep, step, columns, rideItems]);

  const titles = [
    { title: "Type", item: property },
    { title: "Size", item: propertySize },
    { title: "Residents", item: people },
    { title: "Items", item: productsType },
  ];

  const _renderTitles = () => {
    return titles.map((item, index) => {
      return (
        <TitleTextWrapper key={item.title} active={index + 1 === innerStep}>
          <Text style={{ opacity: index + 1 === innerStep ? 1 : 0.4 }}>{`${
            item.title
          }${!!item.item ? ": " : ""}`}</Text>
          {item.item && typeof item.item.title === "string" && (
            <Text
              style={{ opacity: index + 1 === innerStep ? 1 : 0.4 }}
            >{`${item.item.title}`}</Text>
          )}
          {item.item && Array.isArray(item.item) && (
            <Text
              style={{ opacity: index + 1 === innerStep ? 1 : 0.4 }}
            >{`${item.item.map((i) => i.title)}`}</Text>
          )}
        </TitleTextWrapper>
      );
    });
  };

  const _renderStep = useCallback(() => {
    switch (step) {
      case 0:
        return (
          <WizardUnitPage
            roll={roll}
            setRoll={setRoll}
            isDemo={isDemo.current}
            productsType={productsType}
            propertySize={propertySize}
            property={property}
            people={people}
            onChangeCity={setCity}
            city={city}
            name={name}
            setName={setName}
            email={email}
            setEmail={setEmail}
            ipDetails={ipDetails}
            setProperty={setProperty}
            setPropertySize={setPropertySize}
            setPeople={setPeople}
            setProductsType={setProductsType}
            innerStep={innerStep}
            setInnerStep={setInnerStep}
            onFinish={() => {
              setStep(1);
            }}
          />
        );
      case 1:
        if (isDemo.current) {
          return <CreateUnitPageYishai onQuoteClick={handleOpen} />;
        }
        return (
          <CreateUnitPage
            columns={columns}
            rideItems={rideItems}
            setColumns={setColumns}
            setRideItems={setRideItems}
            collectDate={collectDate.current}
            onQuoteClick={handleOpen}
          />
        );

      default:
        return null;
    }
  }, [
    step,
    innerStep,
    city,
    ipDetails,
    roll,
    name,
    email,
    property,
    propertySize,
    people,
    productsType,
    columns,
    rideItems,
  ]);

  return (
    <>
      <Header>
        <img width={111} className={styles.LolinkImg} src={logo1} alt="logo" />
        {orderNumber && !isDemo.current && (
          <div>{`Order number: ${orderNumber}`}</div>
        )}
        <div style={{ width: "111px" }} />
      </Header>
      <div style={{ padding: "60px 0 0" }}>
        {innerStep !== 0 && step === 0 && (
          <UpperSectionWrapper>{_renderTitles()}</UpperSectionWrapper>
        )}
      </div>
      {_renderStep()}
      <FinishModal
        ipDetails={ipDetails}
        property={property}
        propertySize={propertySize}
        people={people}
        productsType={productsType}
        handleClose={handleClose}
        open={open}
      />
    </>
  );
};

const Header = styled.div`
  justify-content: space-between;
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  background-color: white;
  width: 100vw;
  padding: 0.6em;
  box-shadow: 2px 2px 5px #bababa;
`;

const UpperSectionWrapper = styled.div`
  align-items: center;
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: #dcdcdc;
  padding: 20px;
  justify-content: space-around;
  z-index: 9;
`;

const Text = styled.div`
  color: ${({ color = "#4b4b4b" }) => color};
  font-size: 15px;
  line-height: 1.5;
`;

const TitleTextWrapper = styled.div`
  position: relative;
  display: flex;
  width: 23vw;
  border-left: 5px solid ${({ active }) => (active ? "#13647b" : "transparent")};
  padding: 0 5px;
`;
export default CreateUnit;
